import { useContext } from 'react';
import WidgetContext from '../WidgetContext.js';
const useWidget = () => {
    return useContext(WidgetContext);
};
export default useWidget;
